'use client';

import useEmblaCarousel from 'embla-carousel-react';
import type { ReactNode } from 'react';
import { useCallback, useEffect, useState } from 'react';
interface MobileCarouselProps {
  items: ReactNode[];
  className?: string;
  slideClassName?: string;
}

/**
 * Renders a carousel of items that are displayed on mobile devices.
 */
export const MobileCarousel = ({
  items,
  className = '',
  slideClassName = ''
}: MobileCarouselProps) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true
  });
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);
  const scrollTo = useCallback((index: number) => {
    if (emblaApi) {
      try {
        emblaApi.scrollTo(index);
      } catch (error) {
        console.error('Error in scrollTo:', error);
      }
    }
  }, [emblaApi]);
  const onSelect = useCallback(() => {
    if (!emblaApi) {
      return;
    }
    try {
      setSelectedIndex(emblaApi.selectedScrollSnap());
    } catch (error) {
      console.error('Error in onSelect:', error);
    }
  }, [emblaApi, setSelectedIndex]);
  useEffect(() => {
    if (!emblaApi) {
      return;
    }
    try {
      setScrollSnaps(emblaApi.scrollSnapList());
      setSelectedIndex(emblaApi.selectedScrollSnap());
      emblaApi.on('select', onSelect);
      return () => {
        emblaApi.off('select', onSelect);
      };
    } catch (error) {
      console.error('Error in useEffect:', error);
    }
  }, [emblaApi, onSelect]);
  return <div className={`transform transition-transform duration-1000 ${className}`} data-sentry-component="MobileCarousel" data-sentry-source-file="mobile-carousel.tsx">
      <div className="embla overflow-hidden" ref={emblaRef}>
        <div className="embla__container flex">
          {items.map((item, index) => <div key={index} className={`embla__slide flex-[0_0_100%] min-w-0 ${slideClassName}`}>
              {item}
            </div>)}
        </div>
      </div>
      <div className="flex justify-center mt-4">
        <div className="embla__dots flex space-x-2">
          {scrollSnaps.map((_, index) => <button key={index} className={`w-2 h-2 rounded-full ${index === selectedIndex ? 'bg-gray-800' : 'bg-gray-300'}`} onClick={() => scrollTo(index)} />)}
        </div>
      </div>
    </div>;
};